import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, CircularProgress, Tabs, Tab } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Galaryimageupload from './Galaryimageupload';
import Accomplishments from './Accomplishments';
import NewsManagement from './NewsManagement';

import DynamicValuesManager from './DynamicValuesManager';
// import NewsTab from './tabs/NewsTab';
import YouTubeLinksManager from './YouTubeLinksManager';
import AssociationsManager from './AssociationsManager';

import HelpNeededManager from './Helpneededlist';
import AdminUserManagement from './AdminUserManagement'

import Eventimageupload from './Eventimageupload'

const AdminDashboard = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const validateAdmin = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAdmin(false);
        return;
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setIsAdmin(true);
        fetchRequests(token);
      } catch (err) {
        console.error('Admin validation failed:', err);
        setIsAdmin(false);
      }
    };

    const fetchRequests = (token) => {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/getPendingSignUpRequests`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setRequests(res.data))
        .catch((err) => console.error('Error fetching pending requests', err))
        .finally(() => setLoading(false));
    };

    validateAdmin();
  }, []);

  const handleApprove = (email) => {
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/approveSignUp/${email}`, { status: 'approved' })
      .then(() => {
        alert('Signup request approved!');
        setRequests((prev) => prev.filter((request) => request.email !== email));
      })
      .catch((err) => {
        console.error('Error approving request', err);
        alert('Error approving request');
      });
  };

  const handleReject = (email) => {
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/rejectSignUp/${email}`, { status: 'rejected' })
      .then(() => {
        alert('Signup request rejected!');
        setRequests((prev) => prev.filter((request) => request.email !== email));
      })
      .catch((err) => {
        console.error('Error rejecting request', err);
        alert('Error rejecting request');
      });
  };

  if (loading) return <CircularProgress />;
  if (isAdmin === false) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">Access denied. You are not authorized to view this page.</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Go to Home</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>Admin Dashboard</Typography>
      <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)} variant="scrollable">
        <Tab label="Signup Requests" />
        <Tab label="Accomplishments" />
        <Tab label="Dynamic Values" />
        <Tab label="News" />
        <Tab label="YouTube Links" />
        <Tab label="Associations" />
        <Tab label="Gallery Upload" />
        <Tab label="Event Images Upload" />
        <Tab label="Help Needed list" />
        <Tab label="User Management" />
        
      </Tabs>

      <Box sx={{ mt: 3 }}>
        {tabIndex === 0 && (
          <Box>
            <Typography variant="h6">Pending Signup Requests</Typography>
            {requests.length > 0 ? (
              requests.map((request) => (
                <Box key={request.email} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography><strong>Name:</strong> {request.first_name} {request.last_name}</Typography>
                  <Typography><strong>Email:</strong> {request.email}</Typography>
                  <Typography><strong>How did you know about us:</strong> {request.knowabout}</Typography>
                  <Typography><strong>Reason for joining UC:</strong> {request.resonforjoining}</Typography>
                  <Typography><strong>Status:</strong> {request.status}</Typography>
                  <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                    <Button variant="contained" color="success" onClick={() => handleApprove(request.email)}>Approve</Button>
                    <Button variant="contained" color="error" onClick={() => handleReject(request.email)}>Reject</Button>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography>No pending signup requests.</Typography>
            )}
          </Box>
        )}

        {tabIndex === 1 && <Accomplishments />}
        {tabIndex === 2 && <DynamicValuesManager />}
        {tabIndex === 3 && <NewsManagement />}
        {tabIndex === 4 && <YouTubeLinksManager />}
        {tabIndex === 5 && <AssociationsManager />}
        {tabIndex === 6 && <Galaryimageupload />}
        {tabIndex === 7 && <Eventimageupload />}
        {tabIndex === 8 && <HelpNeededManager />}
        {tabIndex === 9 && <AdminUserManagement />}
        
      </Box>
    </Box>
  );
};

export default AdminDashboard;
